<template lang="pug">
  .property
    label(v-if="showLabel") {{ property.name }}
    .values
      template(v-if="property.type === 'color'")
        // TODO: check for image swatch
        template(v-for="el in property.values")
          template(v-if="el.image && el.image.src")
            span.color-image(:style="{ backgroundImage: 'url(' + el.image.src + ')'}")
            //- span.label {{ el.value }}
          template(v-else-if="el.value_alt")
            span.color-tile(:style="{ background: el.value_alt }")
          //- span.text-tile(v-else) {{ el.value }}

      template(v-else)
        .text-tile(v-for="el in property.values")
          | {{ el.value }}
</template>

<script>
export default {
    name: 'TeaserProperty',
    props: {
        property: {
            type: Object,
            required: true
        },
        showLabel: {
            type: Boolean,
            default: false
        }
    }
};
</script>

<style lang="sass" scoped>
.property
  font-size: .85rem
  .text-tile
    @apply rounded
    display: inline
    padding: 3px 6px
    background-color: theme('colors.gray.300')
    margin: 0 2px
  .color-tile
    @apply border-1 border-gray-400
    margin: 0 2px
    display: block
    width: 22px
    height: 22px
  .color-image
    display: inline-block
    position: relative
    isolation: isolate
    width: 22px
    height: 22px
    // background-size: cover
    background-size: 250% 250%
    background-position: center
    border-radius: 50%
    &:after
        content: ''
        position: absolute
        inset: 0
        backdrop-filter: blur(10px) saturate(150%)
        z-index: 10
        border-radius: 50%
    & + .color-image
      margin-left: 2px
</style>
